import React, { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Bannerbgimg } from "assets/images";
import "./CenterLandingpage.scss";
import InstituteToppers from "components/institute-toppers/InstituteToppers";
import FacultiesList from "components/faculties-list/FacultiesList";
import CampusGallery from "components/campus-photos/CampusGallery";
import Testimonials from "components/testimonial/Testimonial";
import ContactusForm from "components/contactus-form/Contactus-form";
import FAQ from "components/FAQs/FAQs";
import { centerBasedLandingPage } from "services/center";
import CourseDetailSkeleton from "components/skeleton/CourseDetailSkeleton";
import YoutubeVideo from "components/video-player/YoutubeVideo";
import CenterMap from "./section/CenterMap";
import UpcomingCourses from "./section/UpcomingCourses";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { faMobileAlt } from '@fortawesome/free-solid-svg-icons';
import {
  errorResponse,
  failResponse,
  normalDecryptData,
  normalEncryptData,
} from "config/config";
import CenterSectionDetails from "components/center-section-details/CenterSectionDetails";
import CityYoutubeVideo from "components/video-player/CityYoutubeVideo";
import NotFound from "pages/not-found/NotFound";

const CenterLanding = () => {
  const { centerId } = useParams();
  const [loading, setLoading] = useState(false);
  const [centerData, setCenterData] = useState({});
  const [examTypes, setExamTypes] = useState([]);
  const [faqs, setFaqs] = useState([]);
  const [centerSections, setCenterSections] = useState([]);
  const [galleryImages, setGalleryImages] = useState([]);
  const [testimonials, setTestimonials] = useState([]);
  const [toppers, setToppers] = useState([]);
  const [faculties, setFaculties] = useState([]);
  const [allCenters, setAllCenters] = useState([]);
  const [type, settype] = useState("center");
  const navigate = useNavigate();
  const [showFull, setShowFull] = useState(false);
  const [centersubheading, setCentersubheading] = useState(null);
  const [notFound, setNotFound] = useState(false);

  // --------------- getting all required masters data ----------------//
  React.useLayoutEffect(() => {
    const getCentersData = async () => {
      try {
        setLoading(true);

        // decrypt the center id and navigate ot home if is invalid
        const rcname = centerId;
        const rcarray = rcname.split("_");

        let centername = rcarray[2];
        let mainId = 0;
        if (centername == "Pune") {
          mainId = 5;
        }
        else if (centername == "Lucknow") {
          mainId = 1;
        }
        else if (centername == "Bengaluru") {
          mainId = 4;
        }
        else if (centername == "Hyderabad") {
          mainId = 3;
        }
        else if (centername == "NewMumbai") {
          mainId = 2;
        }
        else if (centername == "Mumbai") {
          mainId = 13;
        }
        else if (centername == "Jammu") {
          mainId = 6;
        }
        else if (centername == "Nagpur") {
          mainId = 7;
        }
        else if (centername == "Bhubaneswar") {
          mainId = 8;
        }
        else if (centername == "Bhopal") {
          mainId = 9;
        }
        else if (centername == "Chandigarh") {
          mainId = 10;
        }
        else if (centername == "Varanasi") {
          mainId = 11;
        }
        else if (centername == "Delhi") {
          mainId = 12;
        }
        else if (centername == "Jaipur") {
          mainId = 142;
        }
        else if (centername == "Dhanbad") {
          mainId = 143;
        }
        //normalDecryptData(centerId, "route");




        if (!mainId) navigate("/");
        if (mainId === 0) {
          navigate(`*`);
        } else {
          // Proceed with fetching data based on the determined mainId
          const res = await centerBasedLandingPage(
            type === "center" ? { centerpageId: mainId } : { verticleId: mainId }
          );

          if (
            res.code === 200 &&
            res.data?.centerData &&
            Object.keys(res.data.centerData).length > 0
          ) {
            const {
              centerData,
              centerFaq,
              examType,
              center,
              testimonials,
              toppers,
              teachers,
            } = res.data;

            setCenterData(
              {
                ...centerData.center,
                latitude: centerData.latitude,
                longitude: centerData.longitude,
                introductionVideoURL: centerData.introductionVideoURL,
                id: centerData?.id,
              } || {}
            );
            setCentersubheading(centerData?.content || null);
            setGalleryImages(
              centerData?.centerImage.map((image) => {
                return { id: image.id, src: image.imageUrl, width: 6, height: 4 };
              }) || []
            );
            setAllCenters(center || []);
            setFaqs(centerFaq || []);
            setExamTypes(examType || []);
            setCenterSections(centerData?.centersectiondetails || []);
            setTestimonials(testimonials || []);
            setToppers(toppers || []);
            setFaculties(teachers || []);
            setLoading(false);

          } else {
            setNotFound(true)
            failResponse(res);
            setLoading(false);
          }
        }
      } catch (err) {
        errorResponse(err);
        setLoading(false);
      }
    };


    // calls all the master functions
    getCentersData();
    // eslint-disable-next-line
  }, [centerId]);

  if (notFound) {
    return (
      <>
        <NotFound />
      </>
    );
  }

  return (
    <>


      {/* main component */}
      {!loading && (
        <section className="center-landingpage">



          <div
            className="center-landingpage_banner spacing"
            style={{ background: `#ffeded` }}
          >

            <div className="center-container">

              <div className="center-content">
                {centerData.CenterName === "Shubhra Ranjan IAS Study, Delhi 25" ? (
                  <h1>Welcome to Shubhra Ranjan IAS Study, Delhi</h1>
                ) : (
                  <h1>Welcome to {centerData.CenterName}</h1>
                )}

                <p style={{ display: "flex", alignItems: "center", gap: "10px", flexWrap: "wrap", marginBottom: "0px", backgroundColor: "rgb(255, 237, 237)", fontSize: "17px", color: "#333", marginLeft: "2px" }}>
                  {/* Show only City Name */}
                  <span style={{ fontWeight: "600" }}>{centerData.CenterName?.split(",").pop().trim()}:</span>

                  {/* Phone 1 */}
                  {centerData?.Phone1 && (
                    <span style={{ display: "flex", alignItems: "center", gap: "5px", color: "rgb(24, 67, 162)", fontWeight: "500" }}>
                      <FontAwesomeIcon icon={faMobileAlt} style={{ marginRight: "3px", color: "rgb(24, 67, 162)" }} />
                      {centerData.Phone1}
                    </span>
                  )}

                  {/* Phone 2 */}
                  {centerData?.Phone2 && (
                    <span style={{ display: "flex", alignItems: "center", gap: "5px", color: "rgb(24, 67, 162)", fontWeight: "500" }}>
                      <FontAwesomeIcon icon={faMobileAlt} style={{ marginRight: "3px", color: "rgb(24, 67, 162)" }} />
                      {centerData.Phone2}
                    </span>
                  )}
                </p>
                <br />
                {centersubheading ? (
                  <div className="center-subheading">
                    <div
                      className={showFull ? "full-text" : "truncate-text"}
                      dangerouslySetInnerHTML={{ __html: centersubheading }}
                    />
                    {centersubheading && centersubheading.replace(/<[^>]+>/g, "").split(" ").length > 20 && (
                      <button
                        onClick={() => setShowFull(!showFull)}
                        className="read-more-btn-city"
                      >
                        {showFull ? "Read Less" : "Read More"}
                      </button>
                    )}
                  </div>


                ) : (
                  <div className="city-subheading">
                    <p>
                      Join India’s leading institute for Civil services preparation.
                    </p>
                  </div>

                )}


                {/* <div className="banner_button">
                  <div className="button_wrap fill ">
                    <Link to="" className="button">
                      Upcoming Courses
                      <span className="icon">
                        <BsArrowRight />
                      </span>
                    </Link>
                  </div>
                  <Dropdown>
                    <Dropdown.Toggle id="dropdown-basic" className="button">
                      Upcoming Courses
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item href="#/action-2">
                        <label form="Bengaluru">
                          <input type="radio" id="Bengaluru" name="center" />{" "}
                          <span>Bengaluru</span>
                        </label>
                      </Dropdown.Item>
                      <Dropdown.Item href="#/action-3">
                        <label form="bhopal">
                          <input type="radio" id="bhopal" name="center" />{" "}
                          <span>Bhopal</span>
                        </label>
                      </Dropdown.Item>
                      <Dropdown.Item href="#/action-4">
                        <label form="Bhubaneswar">
                          <input type="radio" id="Bhubaneswar" name="center" />{" "}
                          <span>Bhubaneswar</span>
                        </label>
                      </Dropdown.Item>
                      <Dropdown.Item href="#/action-5">
                        <label form="Chandigargh">
                          <input type="radio" id="Chandigargh" name="center" />{" "}
                          <span>Chandigargh</span>
                        </label>
                      </Dropdown.Item>
                      <Dropdown.Item href="#/action-6">
                        <label form="Chennai">
                          <input type="radio" id="Chennai" name="center" />{" "}
                          <span>Chennai</span>
                        </label>
                      </Dropdown.Item>
                      <Dropdown.Item href="#/action-7">
                        <label form="Dehradun">
                          <input type="radio" id="Dehradun" name="center" />{" "}
                          <span>Dehradun</span>
                        </label>
                      </Dropdown.Item>
                      <Dropdown.Item href="#/action-9">
                        <label form="Hyderabad">
                          <input type="radio" id="bhopal" name="center" />{" "}
                          <span>Hyderabad</span>
                        </label>
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div> */}
              </div>
              <div className="center-slider_section">
                <CityYoutubeVideo src={centerData.introductionVideoURL} />
              </div>
            </div>
          </div>

          {/* upcoming Class room course */}
          {centerData.CenterID != "1009" &&
            (
              <UpcomingCourses
                exam={examTypes}
                affiliatecenter={centerData.CenterID}
                centerId={centerData?.id}
                phoneNumber={centerData?.Phone1}
                city={centerData.City}
              />
            )}

          {/*Center Section Details*/}
          {/* <CenterSectionDetails sectionDetails={centerSections} /> */}

          {/* Institute Toppers */}
          <InstituteToppers
            title={`Our Toppers from ${centerData.State}`}
            toppersArray={toppers}
            loading={loading}
          />

          {/* Campus photo gallery */}
          {galleryImages.length != 0 && (
            <CampusGallery galleryImages={galleryImages} city={centerData.City} />
          )}


          {/* Faculties List */}
          <FacultiesList faculties={faculties} loading={loading} />

          {/* Testimonials */}
          <Testimonials testimonials={testimonials} loading={loading} />





          {/* Contact us */}
          <ContactusForm
            center={centerData.City}
            address={centerData.Address}
            centerId={centerData.CenterID}

          />

          {/* FAQ's */}
          {faqs.length > 0 && (<FAQ loading={loading} faqs={faqs} />)}

          {/* center map  */}
          <CenterMap centerData={centerData} />

          {/* Regional Centres */}
          <div className="regional_cetners spacing">
            <div className="container">
              <div className="page_title padding">
                <h3>Regional Centres</h3>
              </div>

              <ul>
                {allCenters &&
                  allCenters.map((center) => {
                    return (
                      <li key={center.id}>
                        <Link
                          to={
                            center.center?.CenterName === "Shubhra Ranjan IAS Study, Delhi 25"
                              ? `/IAS_Institute_Delhi`
                              : `/IAS_Institute_${center.center?.CenterName.replace(
                                "Shubhra Ranjan IAS Study, ",
                                ""
                              )}`
                          }
                          className="button"
                        >
                          {center.center?.CenterName}
                        </Link>

                      </li>
                    );
                  })}
              </ul>

              {/* <h3 className="other_mode">Other Modes</h3>
              <ul>
                <li>
                  <Link to="" className="button">
                    Tablet Mode
                  </Link>
                </li>
              </ul> */}
            </div>
          </div>

          {/* ////////////////////// Number Data /////////////////// */}

          <div className="number_data spacing">
            <div className="container">
              <div className="number_data_content">
                <ul>
                  <li>
                    <h3>62,000 + </h3> <span>Students Tutored</span>
                  </li>
                  <li>
                    <h3>50 + </h3> <span>Courses Offered</span>
                  </li>
                  <li>
                    <h3>20 + </h3> <span>Experienced faculties</span>
                  </li>
                  <li>
                    <h3>8 </h3> <span>Regional Centers</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* loading component */}
      {loading && (
        <div className="course_detail_section">
          <CourseDetailSkeleton />
        </div>
      )}
    </>
  );
};

export default CenterLanding;
